import { QueryClientProvider, QueryClient } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

/**
 * @deprecated This provider uses React Query v3 and is deprecated.
 * Please use QueryProviderV5 from '@tanstack/react-query' for new components.
 * This provider is kept temporarily for backward compatibility during migration.
 *
 * Migration steps:
 * 1. Update imports from 'react-query' to '@tanstack/react-query'
 * 2. Use the withQueryV5 HOC to wrap your component
 * 3. Test that everything works with v5
 * 4. Remove this provider
 */

export const QueryProvider = Object.assign(
  ({ children }: { children: React.ReactNode }) => {
    return (
      <QueryClientProvider client={queryClient}>
        {children}
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    );
  },
  { deprecated: true }
);
